import React from 'react';
import styled from 'styled-components';

import { flex } from '@/styles/theme';

const ThreeDots = (): React.ReactElement => {
  return (
    <DotContainer>
      <Dot />
      <Dot />
      <Dot />
    </DotContainer>
  );
};

export { ThreeDots };

const DotContainer = styled.div.attrs({
  className: `${flex.columnCenter}`,
})`
  margin-top: 4px;
  margin-left: 4px;
`;

const Dot = styled.div`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  border: 1px solid #9a9a9a;
  margin-top: 2px;
`;
